// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge-module__badge___b1jzG {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  line-height: 20px;
  padding: 0 7px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
  font-family: "IBM Plex Mono", monospace;
}

.Badge-module__default___LlD1t {
  background: #f4f4f5;
  color: #3f3f46;
  border: 1px solid #e4e4e7;
}

.Badge-module__outline___bTho8 {
  background: transparent;
  color: #52525b;
  border: 1px solid #d4d4d8;
}

.Badge-module__critical___L2PGO {
  background: #18181b;
  color: #fafafa;
  border: 1px solid #18181b;
}

.Badge-module__escalated___UXHn5 {
  background: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
  font-weight: 600;
}

.Badge-module__flagged___gbuj0 {
  background: #ffffff;
  color: #18181b;
  border: 1px solid #18181b;
  font-weight: 600;
}

.Badge-module__edge___QS8SV {
  background: #ffffff;
  color: #52525b;
  border: 1px dashed #a1a1aa;
}

.Badge-module__green___KDjiT {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.Badge-module__yellow___MTiDE {
  background: #fefce8;
  color: #854d0e;
  border: 1px solid #fde68a;
}

.Badge-module__red___tt5sQ {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.Badge-module__statusDot___X_xJG {
  width: var(--dot-size, 8px);
  height: var(--dot-size, 8px);
  border-radius: 50%;
  background: var(--dot-color, #d4d4d8);
  display: inline-block;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/Badge/Badge.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,0BAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,qCAAA;EACA,qBAAA;EACA,cAAA;AACF","sourcesContent":[".badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  line-height: 20px;\n  padding: 0 7px;\n  border-radius: 4px;\n  font-weight: 500;\n  white-space: nowrap;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.default {\n  background: #f4f4f5;\n  color: #3f3f46;\n  border: 1px solid #e4e4e7;\n}\n\n.outline {\n  background: transparent;\n  color: #52525b;\n  border: 1px solid #d4d4d8;\n}\n\n.critical {\n  background: #18181b;\n  color: #fafafa;\n  border: 1px solid #18181b;\n}\n\n.escalated {\n  background: #fffbeb;\n  color: #b45309;\n  border: 1px solid #fde68a;\n  font-weight: 600;\n}\n\n.flagged {\n  background: #ffffff;\n  color: #18181b;\n  border: 1px solid #18181b;\n  font-weight: 600;\n}\n\n.edge {\n  background: #ffffff;\n  color: #52525b;\n  border: 1px dashed #a1a1aa;\n}\n\n.green {\n  background: #f0fdf4;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.yellow {\n  background: #fefce8;\n  color: #854d0e;\n  border: 1px solid #fde68a;\n}\n\n.red {\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n.statusDot {\n  width: var(--dot-size, 8px);\n  height: var(--dot-size, 8px);\n  border-radius: 50%;\n  background: var(--dot-color, #d4d4d8);\n  display: inline-block;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `Badge-module__badge___b1jzG`,
	"default": `Badge-module__default___LlD1t`,
	"outline": `Badge-module__outline___bTho8`,
	"critical": `Badge-module__critical___L2PGO`,
	"escalated": `Badge-module__escalated___UXHn5`,
	"flagged": `Badge-module__flagged___gbuj0`,
	"edge": `Badge-module__edge___QS8SV`,
	"green": `Badge-module__green___KDjiT`,
	"yellow": `Badge-module__yellow___MTiDE`,
	"red": `Badge-module__red___tt5sQ`,
	"statusDot": `Badge-module__statusDot___X_xJG`
};
module.exports = ___CSS_LOADER_EXPORT___;
